import { style } from '@vanilla-extract/css';

export const emptyState = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1,
  overflowY: 'auto',
});
